$(document).ready(function () {
    // set up the table: sorting, text filter, etc.
    $('#listing').DataTable({
    	"lengthMenu": [ [50, 100, -1], [50, 100, "All"] ],
    	"pageLength": 50
    });
});
